import api from 'api'

const sponsorSections = {
    get: (slug) => {
        return api().get(`/events/detail/${slug}/sponsor-sections`)
    },
    create: (slug, payload) => {
        return api().post(`/events/detail/${slug}/sponsor-sections`, payload)
    },
    update: (slug, id, payload) => {
        return api().put(`/events/detail/${slug}/sponsor-sections/${id}`, payload)
    },
    delete: (slug, id) => {
        return api().delete(`/events/detail/${slug}/sponsor-sections/${id}`)
    },
    createItem: (slug, sectionId, payload) => {
        return api().post(`/events/detail/${slug}/sponsor-sections/${sectionId}/sponsors`, payload)
    },
    updateItem: (slug, sectionId, itemId, payload) => {
        return api().put(`/events/detail/${slug}/sponsor-sections/${sectionId}/sponsors/${itemId}`, payload)
    },
    deleteItem: (slug, sectionId, itemId) => {
        return api().delete(`/events/detail/${slug}/sponsor-sections/${sectionId}/sponsors/${itemId}`)
    },
    uploadItemLogo: (slug, sectionId, itemId, formData) => {
        return api().post(`/events/detail/${slug}/sponsor-sections/${sectionId}/sponsors/${itemId}/logo`, formData)
    }
}

export default sponsorSections
